import { render, staticRenderFns } from "./audit-bank.vue?vue&type=template&id=5e24bddb&scoped=true&"
import script from "./audit-bank.vue?vue&type=script&lang=js&"
export * from "./audit-bank.vue?vue&type=script&lang=js&"
import style0 from "./audit-bank.vue?vue&type=style&index=0&id=5e24bddb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e24bddb",
  null
  
)

export default component.exports